import { Link } from '@tanstack/react-router';
import { Facebook, Linkedin, Youtube } from 'lucide-react';

import { Button } from '@/components/ui/button';

export function Footer() {
  return (
    <footer className="mt-12 border-t border-neutral-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <h3 className="mb-4 font-logo text-xl font-medium leading-relaxed text-neutral-800">
              SolomonQ
            </h3>
            <p className="text-sm text-neutral-600">
              Agregator de știri financiare românești, oferind actualizări în
              timp real de la surse de încredere.
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-medium text-neutral-800">
              LINKURI RAPIDE
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/" className="text-neutral-600 hover:text-primary">
                  Acasă
                </a>
              </li>
              <li>
                <a
                  href="/graphs"
                  className="text-neutral-600 hover:text-primary">
                  Grafice
                </a>
              </li>
              <li>
                <a
                  href="/create-alert"
                  className="text-neutral-600 hover:text-primary">
                  Creează Alertă AI
                </a>
              </li>
              <li>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSe8FYp4NzLHZqDMjSbqQAabSBTCK0wWSdcvodPPjhzHPmvn6Q/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-600 hover:text-primary">
                  Feedback
                </a>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-neutral-600 hover:text-primary">
                  Termeni și Condiții
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-medium text-neutral-800">
              ALERTĂ AI
            </h3>
            <p className="mb-4 text-sm text-neutral-600">
              Primește cele mai recente știri financiare direct în inbox.
            </p>
            <Button
              className="w-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90"
              asChild>
              <Link to="/create-alert">Notificări în timp real</Link>
            </Button>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between border-t border-neutral-200 pt-8 sm:flex-row">
          <p className="mt-3 text-sm text-neutral-500">
            &copy; 2026 SolomonQ. Toate drepturile rezervate.
          </p>
          <div className="mt-4 flex space-x-6 sm:mt-0">
            <a
              href="https://www.facebook.com/people/SolomonQ/61583329600609/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-neutral-500 hover:text-primary">
              <Facebook className="h-5 w-5" />
            </a>
            <a
              href="https://www.youtube.com/@SolomonQ-ro"
              target="_blank"
              rel="noopener noreferrer"
              className="text-neutral-500 hover:text-primary">
              <Youtube className="h-5 w-5" />
            </a>
            <a
              href="https://www.linkedin.com/company/solomonq/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-neutral-500 hover:text-primary">
              <Linkedin className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
